import { useAuthStateValue, useUserEmails } from '@/auth/authentication';
import { initDatadog } from '@/datadog';
import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';
import invariant from 'tiny-invariant';

export const useDatadog = () => {
    const authState = useAuthStateValue();
    const { currentUserEmail, spoofingUserEmail } = useUserEmails();

    useEffect(() => {
        if (!datadogRum.getInitConfiguration()) {
            initDatadog();
        }
    }, []);

    useEffect(() => {
        if (authState) {
            if (!datadogRum.getInitConfiguration()) {
                initDatadog();
            }
            invariant(currentUserEmail, 'Current user email is required');
            const user = {
                id: authState.uuid,
                email: authState.email,
                spoofing_user_email: spoofingUserEmail,
                org: {
                    name: authState.organization.name,
                    id: authState.organization.uuid,
                },
            };
            datadogRum.setUser(user);
            datadogLogs.setUser(user);
        }
    }, [authState, currentUserEmail, spoofingUserEmail]);
};
